export const logListRoutes = {
  path: '',
  name: 'LogList',
  component: () => import('@/views/systemlog/index.vue'),
  meta: {
    hidden: false,
    title: 'System Log'
  }
}



